import $ from 'jquery';

function CommonCtrl() {
	this.$win  = $(window);
	this.$doc  = $(document);
	this.$body = $('body');

	this.$editor = $('.entry-post, .entry-page');

	this.editor = this.editor.bind(this);

	this.init();
}

CommonCtrl.prototype.init = function() {
	// this.$win.on('load', this.editor);
}

CommonCtrl.prototype.editor = function() {
	this.$editor.find('iframe').each(function() {
		let _this = $(this);
		let className = 'iframe';
		let src = _this.attr('src');
		let w = _this.attr('width');
		let h = _this.attr('height');
		if (/youtube\.com/.test(src)) {
			className += ' iframe-youtube';
		}

    _this.wrap('<div class="iframe-max"></div>');
		_this.wrap('<div class="' + className + '"></div>');
		if (_this.parent().hasClass('iframe')) {
			var size = (h / w * 100);
      _this.parent().css('padding-bottom', size + '%');
      $('.iframe-max').css('max-width', w+'px');
		}
	})
}

export default CommonCtrl;

